import { mixin } from 'cssapi'
import { assoc, reduce } from 'ramda'
import { ensureArray } from 'ramda-adjunct'
import { css } from 'styled-components'
import { firstToUpper } from '../../helpers/formatting'

const defaultBorder = api => (edges = [`top`], color = `c:text`) => {
  const edgeStyles = reduce(
    (edgeStylesObj, edge) =>
      assoc(`border${firstToUpper(edge)}`, `5px solid ${color}`, edgeStylesObj),
    {},
    ensureArray(edges)
  )
  return css`
    ${api(edgeStyles)};
  `
}

export default mixin(defaultBorder)



// WEBPACK FOOTER //
// ./src/components/styles/mixins/defaultBorder.js